import React, { Component, PropTypes } from 'react';
import shallowCompare from 'react-addons-shallow-compare';
import { displayCreationModal } from 'saas/sites/modals';
import cx from 'classnames';
import { connect } from 'react-redux';
import { selectSite, unselectSite } from '../actions/sites';
import { getSites } from '../reducers/sites';
import { getSelectedSite, getCustomerId, getErrors } from '../reducers/form';
import Dropdown from 'common/components/Dropdown';

class SiteSelector extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  _onAddSite(evt) {
    evt.stopPropagation();
    evt.preventDefault();

    const onSaved = this.props.onAdded;

    // Displaying site modal
    displayCreationModal(this.props.customer, onSaved);
  }

  shouldComponentUpdate(nextProps) {
    return shallowCompare(this, nextProps);
  }

  render() {
    const { sites, siteId, onSelected, errors } = this.props;

    const renderDefault = () => (
      <div className="default text">Choisissez un site</div>
    );

    const renderSite = site => (
      <div key={site.id} data-value={site.id} className="item">
        {site.name} - {site.address} {site.zipCode} {site.city}
      </div>
    );

    const fieldClass = cx('field required', {
      error: errors.includes('siteId'),
    });

    const isSiteSelected = s => siteId.toString() === s.id.toString();

    const filteredSites = sites.filter(
      s => s.deleted !== true || isSiteSelected(s)
    );

    const onSiteChange = id => {
      onSelected(filteredSites.find(s => s.id.toString() === id));
    };

    return (
      <div className="field">
        <div className={fieldClass}>
          <label>3- Choisir le site</label>
          <Dropdown
            name="ref_site_id"
            value={siteId}
            items={sites}
            renderDefault={renderDefault}
            renderItem={renderSite}
            onChange={onSiteChange}
          />
        </div>
        <div className="field" />
      </div>
    );
  }
}

SiteSelector.propTypes = {
  sites: PropTypes.array.isRequired,
  siteId: PropTypes.number.isRequired,
  onSelected: PropTypes.func.isRequired,
  onUnselected: PropTypes.func.isRequired,
  monoSite: PropTypes.bool,
  errors: PropTypes.array.isRequired,
};

const mapStateToProps = state => ({
  sites: getSites(state),
  siteId: getSelectedSite(state),
  customer: getCustomerId(state),
  errors: getErrors(state),
});

const mapDispatchToProps = dispatch => ({
  onSelected: site => dispatch(selectSite(site)),
  onUnselected: site => dispatch(unselectSite(site)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SiteSelector);



// WEBPACK FOOTER //
// ./src/modules/saas/aast/common/modals/case-transfer/components/SiteSelector.js